'use client';

import { usePathname } from 'next/navigation';
import headerVal from '../../settings/header.val';
import { useVal } from '../../val/val.client';
import classNames from 'classnames';
import Link from 'next/link';

const MainNav = () => {
  const { navigationItems: navItems, contactItem } = useVal(headerVal);
  const pathname = usePathname();

  const isFrontPage = pathname === '/';
  const isProjectTalkPage = pathname === '/prosjektprat';

  if (isFrontPage || isProjectTalkPage) {
    return null;
  }

  return (
    <>
      <div
        className={`hidden laptop:flex bg-blank-black flex-row items-center gap-x-24 px-16 py-12 pointer-events-auto`}
      >
        {navItems.map((item, i) => {
          const isCurrentPage = !!pathname?.includes(item.url);
          return (
            <NavLink key={i} isCurrentPage={isCurrentPage} href={item.url}>
              {item.title}
            </NavLink>
          );
        })}
      </div>

      <div className="hidden laptop:flex bg-blank-black px-16 pr-[80px] py-12 pointer-events-auto">
        {/* Add right padding to make space for darkside toggle */}
        <NavLink
          href={contactItem.url}
          isCurrentPage={!!pathname?.includes(contactItem.url)}
        >
          {contactItem.title}
        </NavLink>
      </div>
    </>
  );
};

const NavLink: React.FC<{
  children: React.ReactNode;
  href: string;
  isCurrentPage: boolean;
}> = ({ href, children, isCurrentPage }) => {
  return (
    <Link
      href={href}
      className={classNames('no-underline hidden laptop:inline', {
        'nav-selected': isCurrentPage,
      })}
    >
      {children}
    </Link>
  );
};

export default MainNav;
